import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

const List = styled.ul`
  &&& {
    position: absolute;
    width: 99.2%;
    top: 69px;
    z-index: 1;
    padding: 5px 0;
    margin: 2px 0 0;
    font-size: 14px;
    text-align: left;
    list-style: none;
    background-color: #fff;
    -webkit-background-clip: padding-box;
    background-clip: padding-box;
    border: 1px solid #ccc;
    border-top: 0px;
    border-radius: 4px;
    border-top-right-radius: 0;
    border-top-left-radius: 0;
    -webkit-box-shadow: 0 6px 12px rgba(0,0,0,.175);
    box-shadow: 0 6px 12px rgba(0,0,0,.175);
    background-color: white;
  }
`
const ListItem = styled.li`
  &&& {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    cursor: pointer;
    position: relative;
    margin: 0;
    padding: 9px 10px 9px 10px;
    line-height: 15px;
    text-align: left;
    white-space: nowrap;
    border: solid 1px transparent;
    border-bottom-width: 1px;
    border-bottom-style: solid;
    border-bottom-color: #e5e5e5;
    border-bottom-color: transparent;
    opacity: .8;
    filter: alpha(opacity=80);
    &:hover {
      background: #cccccc;
    }
  }
`
const AddressLine1 = styled.span`
    font-weight: 600;
    font-size: 12px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`
const AddressLine2 = styled.span`
    font-style: italic;
    font-size: 10px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`

const AddressList = props => {
  const { matchedAddresses, retrieveAddress } = props
  return (
    <List>
      {matchedAddresses.map((address, index) => (
        <ListItem onMouseDown={() => { retrieveAddress(address.Id) }} key={address.Id}>
          <AddressLine1>{address.Text}</AddressLine1>
          <AddressLine2>{address.Description}</AddressLine2>
        </ListItem>
      ))}
    </List>)
}
AddressList.propTypes = {
  matchedAddresses: PropTypes.array,
  retrieveAddress: PropTypes.func,
}
export default AddressList



// WEBPACK FOOTER //
// ./src/containers/Cart/Address/AddressList.js